import { inject } from 'aurelia';

import notifications from '../resources/notifications-manager';
import { TokenService } from './token-service';

const AUTHORIZATION_HEADER = 'Authorization';

@inject(TokenService)
export class ApiInterceptor {
    constructor(private tokenService: TokenService) {}

    async request(request: Request) {
        try {
            if (request.headers.has('X-Skip-Interceptor')) {
                return request;
            }

            const storedToken = await this.tokenService.getToken();

            if (storedToken && !request.headers.get(AUTHORIZATION_HEADER)) {
                const bearerToken = `Bearer ${storedToken}`;
                request.headers.append(AUTHORIZATION_HEADER, bearerToken);
            }

            return request;
        } catch (e) {
            console.log(e);
            notifications.toast('If this error continues, please contact support.', 'error', 'Something went wrong.').show();
        }
    }

    async response(response: Response) {
        try {
            if (response?.status >= 400 && response?.status <= 599) {
                if (response?.status === 404) {
                    return;
                }

                if (response?.status === 401) {
                    this.destroyToken();

                    if (!response.headers?.get('content-type')?.includes('application/json')) {
                        return;
                    }
                }

                const data = await response.json();
                let msg = data.Message || data.message || (typeof data === 'string' ? data : undefined);

                if (!data.skipToast) {
                    if (msg) {
                        const titleDependingOnMessage = 'Error';
                        msg.endsWith('.') ? msg : msg = msg + '.';
                        notifications.toast(msg.replace(/(?:\r\n|\r|\n)/g, '<br />'), 'error', titleDependingOnMessage).show();
                    }

                    if (data.validationErrors) {
                        let errorMsg = '';

                        Object.keys(data.validationErrors).forEach((key) => {
                            data.validationErrors[key].forEach(m => {
                                errorMsg += `${m}<br>`;
                            });
                        });

                        notifications.toast(errorMsg).show();
                    }
                }

                new Error(msg);
            }

            return response;
        } catch (e) {
            console.log(e);
            notifications.toast('If this error continues, please contact support.', 'error', 'Something went wrong').show();
        }
    }

    destroyToken() {
        window.localStorage.removeItem('jwt_token');
    }
}
